
const Privacy = () => {
  return (
    <div className="container">
      <h1>Privacy Policy</h1>
      <p>Last updated: March 2025</p>

      <h2>1. Introduction</h2>
      <p>
        This website, myapple.gr, respects your privacy and is committed to protecting any personal information you provide.
      </p>

      <h2>2. Cookies</h2>
      <p>
        We use cookies to enhance your experience and to analyze website traffic via Google Analytics. These cookies are only activated after you give consent.
      </p>

      <h2>3. Analytics</h2>
      <p>
        Google Analytics may collect anonymized data such as your device type, location (approximate), and pages visited.
      </p>

      <h2>4. Data Collection</h2>
      <p>
        No personally identifiable information is collected unless explicitly submitted through contact forms.
      </p>

      <h2>5. Contact</h2>
      <p>
        For any questions about this policy, please contact <a href="mailto:info@myapple.gr">info@myapple.gr</a>.
      </p>
    </div>
  );
};

export default Privacy;
